<template>
    <client-page>
        <sub-visual tit="자주묻는질문" sc="자주묻는질문 서브텍스트가 들어갑니다." bg="/images/sub/visual/sv-question.jpg" />
        <section class="section">
            <v-container>
                <faq-list />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import FaqList from "@/components/client/center/faqs/faq-list.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";

export default {
    components: {
        ClientPage,
        FaqList,
        SubVisual,
    },
};
</script>
